import React, { useCallback } from 'react';
import { prop } from 'js/utils/ramda.util';
import Image from 'js/components/common/Image';
import { useGameImageUrl } from 'js/hooks/games';
import { useDeviceSelector } from 'js/store/hooks';
import { Button } from 'js/components/common/Button';
import { useLaunchGame } from 'js/hooks/gameLauncher';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import style from './TableItem.scss';

export const TableItem = (props) => {
    const launchGame = useLaunchGame();
    const translate = useComponentTranslations();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const { gameCode: code, player, winAmount, gameName, className } = props;
    const { imageUrl, onError } = useGameImageUrl({ code });

    const openGame = useCallback(() => launchGame({ code, mode: 1 }), [code, launchGame]);

    return (
        <div className={`${style.tableContainer} ${className}`}>
            <Image
                alt={gameName}
                src={imageUrl}
                onError={onError}
                className={style.image}
            />
            {isDesktop
                ? (
                    <>
                        <div className={style.info}>
                            <p className={style.player}>{player}</p>
                            <p className={style.ellipsis}>{gameName}</p>
                        </div>
                        <div className={style.win}>
                            <p className={`${style.justWon} ${style.ellipsis}`}>{translate('justWon')}</p>
                            <p className={style.winAmount}>{winAmount}</p>
                        </div>
                    </>
                )
                : (
                    <div className={style.columnInfo}>
                        <span className={`${style.justWon} ${style.ellipsis}`}>{`${player} ${translate('justWon')}`}</span>
                        <span className={style.winAmount}>{winAmount}</span>
                        <span className={style.ellipsis}>{`${translate('inGame')} ${gameName}`}</span>
                    </div>
                )
            }
            <div className={style.buttonContainer}>
                <Button
                    type="button"
                    onClick={openGame}
                    {...!isDesktop && { size: 'small' }}
                    aria-label={`${translate('play')} ${gameName}`}
                >
                    {translate('play')}
                </Button>
            </div>
        </div>
    );
};
